import React from "react";

function PrivacyPolicy() {
  return (
    <main className="policy-page">
      <div className="container-fluid px-lg-5">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-10">

            {/* Header */}
            <header className="policy-header text-center mb-5">
              <h1>Privacy Policy</h1>
              <p className="policy-subtitle">
                EnergyIndia respects your privacy and is committed to protecting
                your personal and business information.
              </p>
            </header>

            {/* Content */}
            <section className="policy-content">

              <article>
                <h2>1. Introduction</h2>
                <p>
                  This Privacy Policy explains how <strong>EnergyIndia</strong>
                   collects, uses, stores, and protects information obtained
                  from users accessing our power and energy industry directory.
                </p>
              </article>

              <article>
                <h2>2. Information We Collect</h2>
                <ul>
                  <li>Business and contact information voluntarily submitted</li>
                  <li>Technical data such as IP address, browser type, and device</li>
                  <li>Usage data related to pages visited and interactions</li>
                </ul>
              </article>

              <article>
                <h2>3. Use of Information</h2>
                <p>
                  The information collected is used strictly for:
                </p>
                <ul>
                  <li>Maintaining accurate power industry listings</li>
                  <li>Improving platform performance and usability</li>
                  <li>Responding to inquiries and support requests</li>
                  <li>Ensuring regulatory and operational compliance</li>
                </ul>
              </article>

              <article>
                <h2>4. Data Protection & Security</h2>
                <p>
                  EnergyIndia implements industry-standard security measures to
                  safeguard information against unauthorized access, alteration,
                  or disclosure.
                </p>
              </article>

              <article>
                <h2>5. Third-Party Disclosure</h2>
                <p>
                  We do not sell or trade personal data. Limited information may
                  be shared with trusted service providers solely for operational
                  purposes under strict confidentiality agreements.
                </p>
              </article>

              <article>
                <h2>6. Cookies & Analytics</h2>
                <p>
                  Cookies may be used to enhance user experience and analyze
                  website traffic. Users can control cookie preferences through
                  browser settings.
                </p>
              </article>

              <article>
                <h2>7. Policy Updates</h2>
                <p>
                  This Privacy Policy may be updated periodically to reflect
                  changes in regulatory requirements or platform functionality.
                </p>
              </article>

              <article>
                <h2>8. Contact Information</h2>
                <p>
                  For any privacy-related concerns, please contact us at:
                  <br />
                  <strong>Email:</strong> anekant.prakashan@gmail.com
                </p>
              </article>

            </section>

          </div>
        </div>
      </div>
    </main>
  );
}

export default PrivacyPolicy;
